module.exports = __webpack_public_path__ + "img/landing-main-image.639872cb.png";